var _g, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoplay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_617)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6178 46.2136C62.6178 50.7063 58.9758 54.3483 54.4832 54.3483V59.7713C61.9708 59.7713 68.0409 53.7015 68.0409 46.2136C68.0409 38.726 61.9708 32.656 54.4832 32.656H51.7716V30.8483C51.7716 29.7516 51.1109 28.7629 50.0977 28.3432C49.0845 27.9235 47.9182 28.1555 47.1427 28.931L42.6235 33.4502C41.848 34.2257 41.616 35.392 42.0357 36.4052C42.4554 37.4185 43.4441 38.0791 44.5409 38.0791H54.4832C58.9758 38.0791 62.6178 41.7211 62.6178 46.2136ZM30.0793 46.2136C30.0793 41.7211 33.7213 38.0791 38.2139 38.0791V32.656C30.7262 32.656 24.6562 38.726 24.6562 46.2136C24.6562 53.7015 30.7262 59.7713 38.2139 59.7713H40.9255V61.579C40.9255 62.6758 41.5861 63.6646 42.5993 64.0843C43.6126 64.5039 44.7789 64.2719 45.5544 63.4964L50.0737 58.9772C50.8492 58.2017 51.0811 57.0354 50.6614 56.0222C50.2416 55.009 49.253 54.3483 48.1563 54.3483H38.2139C33.7213 54.3483 30.0793 50.7063 30.0793 46.2136Z",
    fill: "black"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 44.2885,
    stroke: "white",
    strokeWidth: 5.42308
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.3846,
    height: 43.3846,
    fill: "white",
    transform: "translate(24.6562 24.5215)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoplay);
export default __webpack_public_path__ + "static/media/autoplay.c51e3d8a207670938259798bfecdfcb0.svg";
export { ForwardRef as ReactComponent };